import { useState } from 'react';
import { INavigationItem } from 'modules/stroyblok/types';

export const useMultiLvlNavigation = () => {
  const MAXIMUM_NAV_LEVEL = 3;

  const [items, setItems] = useState<INavigationItem[]>(
    Array(MAXIMUM_NAV_LEVEL).fill({}),
  );

  return {
    breadcrumbs: items.reduce((acc, item) => {
      if (item?._uid) {
        acc.push(item.title);
      }
      return acc;
    }, [] as string[]),
    nextLvlList: items,
    addNewLvl: (navigationItem: INavigationItem) => {
      const index = items.findIndex((item) => !item?._uid);

      setItems((prev) => {
        const newList = [...prev];
        newList[index] = navigationItem;
        return newList;
      });
    },
    back: () => {
      const index = items.findIndex((item) => !item?._uid) - 1;

      setItems((prev) => {
        const newList = [...prev];
        newList[index] = {} as INavigationItem;
        return newList;
      });
    },
  };
};
